<script>
import ListSolution from '@components/List/Solution'

export default {
  components: {
    ListSolution,
  },
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      },
    },
    logo: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      currentList: [],
    }
  },
  computed: {
    formattedList() {
      return this.list.map((item) => ({
        title: item.title,
        publish_up: item.publish_up,
        description: item.description,
        brands: item.brands,
        to: {
          name: 'brand-solution-item',
          params: {
            brandAlias: this.$route.params.brandAlias,
            categoryAlias: item.category_alias,
            solutionAlias: item.alias,
          },
        },
      }))
    },
  },
  created() {
    // const initData = () => {
    //   const data = this.list.filter((item, i, arr)=> {
    //     const length = arr.length
    //     return length - 3 <= i
    //   })
    //   this.currentList = data;
    // }
    // initData()
  },
}
</script>
<template>
  <section id="solution" class="section bg-gray-2">
    <div class="container">
      <BaseSectionTitle title="解決方案" class="text-center" />
      <ListSolution v-if="list" :row="3" type="brandHome" :list="formattedList" />
      <div class="text-center position-relative" style="z-index: 0">
        <BaseButton class="isStylePrimary isRadius isCol4" :to="{ name: 'brand-solution-list' }"> 查看所有解決方案 </BaseButton>
      </div>
    </div>
  </section>
</template>
